import { Link } from "react-router-dom";
import { useStore } from "src/stores/Store";
import tw from "src/utils/tw";

interface Props {
  onClick?: (key) => void;
  activeKey?: string;
  active?: boolean;
  tabKey?: string;
  children: any;
  className?: string;
  to?: string;
}

export default function TabButton(props: Props) {
  const store = useStore();

  let borderClass = "border-main";

  if (store.isAccountArea && !store.user?.isStaff) {
    borderClass = "border-organization";
  }

  if (props.to) {
    return (
      <Link
        className={tw(
          "mr-4 inline-block cursor-pointer truncate border-b-2 py-2 pr-1 align-bottom font-bold",
          (props.activeKey && props.activeKey === props.tabKey) || props.active
            ? `${borderClass} text-dark`
            : "border-transparent text-organization",
          props.className
        )}
        to={props.to}
        onClick={props.onClick}
      >
        {props.children}
      </Link>
    );
  }

  return (
    <button
      className={tw(
        "mr-4 inline-block cursor-pointer truncate border-b-2 px-1 py-2 font-bold",
        (props.activeKey && props.activeKey === props.tabKey) || props.active
          ? `${borderClass} text-dark`
          : "border-transparent text-organization",
        props.className
      )}
      onClick={() => props.onClick(props.tabKey)}
    >
      {props.children}
    </button>
  );
}
